
import { Component, OnInit, ViewChild } from '@angular/core';
import { Contenido } from '../../domain/Contenido';
import { Idioma } from '../../domain/Idioma';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { TranslateService } from 'ng2-translate';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AppComponent } from '../../app.component';
import { Predicate } from 'breeze-client';
import { takeUntil } from 'rxjs/operator/takeUntil';
import { Permisos, PermisosService } from '../../providers/authentication/permisos.service';

const FILTRO_INI = JSON.stringify({
	where: {
		Titulo: '',
		estado: 4,
		// expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
		Desde: '',
		Hasta: '',
		ElementoAsignado: '',
		IdAlternativo: '',
		Tipologia: ''
	},
	order: 'Titulo DESC',
	top: 10,
	page: 0,
	total: 0
});


@Component({
	selector: 'app-tabla-asignacion-contenidos',
	templateUrl: './tabla-asignacion-contenidos.component.html',
	styleUrls: ['./tabla-asignacion-contenidos.component.css']
})

export class TablaAsignacionContenidosComponent implements OnInit {
	@ViewChild('dt_no_asignados') dt_no_asignados;
	@ViewChild('pg_no_asignados') pg_no_asignados;

	spinner: HTMLElement;
	blockUI: HTMLElement;

	// Contenido asociado
	contenidosTodos: Contenido[] = [];
	contenidosFiltrados: Contenido[] = [];
	public contenidoSeleccionado: Contenido[] = [];
	public displayDialog: boolean = false;
	public filtro = JSON.parse(FILTRO_INI);

	public tipologiasContenido = [{
		tipo: 'TODOS',
		value: 'TODOS',
		clases: [],
		label: 'Todos'
	}];
	public tipologiasContenidoSeleccionada = this.tipologiasContenido[0];

	triggerPageChange: boolean = true;
	public ContenidoEstado = [
		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'Contenidos.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all'],
			label: 'Contenidos.estadoActivo'
		},
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'Contenidos.estadoProximo'
		},
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'Contenidos.estadoExpirado'
		}
	];

	public ContenidoEstadoMod = this.ContenidoEstado[0];

	public colsTodos: any[] = [];

	public msgAvisoContenido = [];

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;
	permisos: Permisos;
	// ---

	constructor(
		private idiomaService: IdiomaService,
		private appComponent: AppComponent,
		public sws: ServiciosWebServiceProvider,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		private translate: TranslateService,
		private permisosService: PermisosService
	) {

		this.msgAvisoContenido = [];

		this.msgAvisoContenido.push({ severity: 'info', detail: this.translate.instant('Mensajes.avisoasignarcontenido') });

		this.colsTodos = [
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen') }, // clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo') }, // clases: ['th-tipo-normal'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado') }, // clases: ['th-tipo-corto2'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo') }, // clases: ['th-tipo-medio'] },
			{ field: 'TIPOLOGIA_CONTENIDO', fieldSort: 'Tipologia', header: this.translate.instant('Contenidos.tipologia') }, // clases: ['th-tipo-medio'] },
			{ field: 'MostrarEdicion', fieldSort: '', header: '' }
		];
	}

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'inherit';

		// Mostramos Spinner
		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			return that.cargarContenidos();
		})
		.then(function(){
			that.spinner.style.display = 'none';
		})
		.catch(function(){
			that.spinner.style.display = 'none';
		});

	}

	/* TABLA ASIGNACION CONTENIDO */
	onInputSearchChange() {
		const _where = this.filtro.where;
		this.filtro = JSON.parse(FILTRO_INI);
		this.filtro.where = _where;
		this.cargarContenidos();
	}

	filterTipologia(TIPOLOGIA_CONTENIDO) {
		const valorFiltrado = TIPOLOGIA_CONTENIDO.Nombre;

		this.filtro.where.Tipologia = valorFiltrado;

		this.cargarContenidos();
	}

	filterEstado(filter) {
		this.filtro.where.estado = filter.value;
		this.cargarContenidos();
	}


	getContenidoEstado(_val) {
		for (const i in this.ContenidoEstado) {
			if (this.ContenidoEstado[i].value === _val) {
				return this.ContenidoEstado[i];
			}
		}
		return {};
	}

	onPageChange(evento) {
		console.log(evento);
		this.filtro.page = evento.page;
		if (this.triggerPageChange) {
			this.cargarContenidos();
		} else {
			this.triggerPageChange = true;
		}
	}

	asignarContenido(rowData) {

		// Asignamos contenidos
		const idContenido = rowData.ENTIDAD.Id ? rowData.ENTIDAD.Id : rowData.Id;

		this.contenidosTodos = this.contenidosTodos.filter(obj => obj.ENTIDAD.Id !== idContenido);
		this.contenidoSeleccionado = new Array();
		this.contenidoSeleccionado.push(rowData);

		let filtroNoAsignados;;


		if (this.dt_no_asignados.filters) {
			filtroNoAsignados = this.dt_no_asignados.filters;
		}

		if (filtroNoAsignados !== undefined) {
			this.dt_no_asignados.reset();
			this.dt_no_asignados.filters = filtroNoAsignados;
			this.dt_no_asignados.filter();
		} else {
			this.dt_no_asignados.reset();
		}


		this.filtro.total = this.contenidosTodos.length;

		if (this.contenidosTodos.length === 0 && this.filtro.page > 0) {
			this.filtro.page--;

			this.pg_no_asignados.paginatorState.page = this.filtro.page;
			this.pg_no_asignados.paginatorState.totalRecords = this.filtro.total;

			this.pg_no_asignados.changePage(this.filtro.page);
		}

		this.displayDialog = false;
	}

	desasignarContenido(rowData) {
		this.contenidosTodos.push(rowData);
		this.contenidoSeleccionado = new Array();

		// ASIGNADOS
		let value = '';
		let matchMode = '';
		if (this.dt_no_asignados.filters && this.dt_no_asignados.filters.global) {
			value = this.dt_no_asignados.filters.global.value;
			matchMode = this.dt_no_asignados.filters.global.matchMode;
		}

		this.dt_no_asignados.reset();
		this.dt_no_asignados.filterGlobal(value, matchMode);

		// NO ASIGNADOS
		value = '';
		matchMode = '';
	}

	mostrarEditar(rowdata) {
		rowdata.MostrarEdicion = true;
	}

	ocultarEditar(rowdata) {
		rowdata.MostrarEdicion = false;
	}

	mostrarAsignarContenido() {
		this.cargarContenidos();
		this.displayDialog = true;
	}


	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

	cargarContenidos() {
		const that = this;
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const columnas = [];
		const token = this.authService.getToken();

		const idIdioma = this.idiomaSeleccionado.ENTIDAD.Id;

		const idEspacio = this.authService.getIdEspacio();
		const _elementoAsignado = this.filtro.where['ElementoAsignado'];
		const _titulo = this.filtro.where['Titulo'];
		const _idAlternativo = this.filtro.where['IdAlternativo'];

		let _tipologia = '';
		if (this.filtro.where.Tipologia && this.translate.instant('Contenidos.estadoTodos') !== this.filtro.where.Tipologia.toString()) {
			_tipologia = this.filtro.where['Tipologia'];
		}
		let size = 10;
		let first = this.filtro.page * size;

		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const _estado = this.filtro.where.estado;
		const Desde = this.filtro.Desde;
		const Hasta = this.filtro.Hasta;

		let ids = [];

		let excluidos = new Array();
		that.contenidosTodos = new Array();

		let Activos = false;
		if (that.permisos.Gestion_Activos === 2) {
			Activos = true;
		}

		// this.entityManager.getCONTENIDOOrdenado(where, order, top, page, includes, columnas )
		this.sws.wsBuscarContenidos(token, idEspacio, idIdioma, _titulo, _estado, Desde, Hasta, _idAlternativo, _tipologia, _elementoAsignado, first, size, orderBy, order, excluidos, Activos).toPromise()
			.then(function (resp) {
				ids = resp.lista;

				that.filtro.total = resp.total;
				let includes = 'FOTOS, ';
				includes = includes + 'IDIOMAS, ';
				includes = includes + 'ALAS.ALA.IDIOMAS, ';
				includes = includes + 'ESPACIOS.ESPACIO.IDIOMAS, ';
				includes = includes + 'SECCIONES.SECCION.IDIOMAS, ';
				includes = includes + 'NODODS.NODO.SECCION, ';
				includes = includes + 'TIPOLOGIA_CONTENIDO.IDIOMAS';

				return that.entityManager.getContenidosById(ids, includes, columnas);
			})
			.then(function (data) {
				that.contenidosTodos = [];
				that.contenidosFiltrados = [];

				// Ordenamos los contenidos segun el orden en el que obtuvimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
				data = data.sort(function (a, b) {
					return ids.indexOf(a.Id) - ids.indexOf(b.Id);
				});

				data.forEach(cont => {
					try {
						const contenido = new Contenido().fromENTIDAD(cont);
						if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === '') {
							contenido.Imagen = that.authService.getFotoPorDefecto();
						}
						that.contenidosFiltrados.push(contenido);
					}
					catch (ex) {
						that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR'));
					}
				});

				that.contenidosFiltrados.forEach(elemento => {
					if (elemento.Imagen === undefined) {
						elemento.Imagen = that.authService.getFotoBlobPorDefecto();
					}
				});

				// AQUI VER COMO FILTRARIA LOS CONTENIDOS YA ASIGNADOS DEPENDIENDO DE DONDE SE CARGUE ESTE COMPONONTE, SEGURAMENTE SEA CON UN INPUT
				/*
				const conts = that.contenidosFiltrados.find( c => c.Id === that.AvisoSeleccionado.ENTIDAD.IdContenido);
				if(conts){
					that.contenidoSeleccionado = [conts];
					that.contenidosFiltrados.filter( c => c.Id !== that.AvisoSeleccionado.ENTIDAD.IdContenido);
				}
				*/

				that.contenidosFiltrados.forEach((contenidoFormulario: Contenido) => {
					const contenido = new Contenido().fromENTIDAD(contenidoFormulario.ENTIDAD);
					that.contenidosTodos.push(contenido);
				});

				that.dt_no_asignados.reset();

				// Traducimos Contenidos al idioma seleccionado
				that.contenidosFiltrados = that.idiomaService.traducirContenidos(that.contenidosFiltrados, that.idiomaSeleccionado);
				that.triggerPageChange = false;

				that.pg_no_asignados.paginatorState.page = that.filtro.page;
				that.pg_no_asignados.paginatorState.totalRecords = that.filtro.total;

				that.pg_no_asignados.changePage(that.filtro.page);

				that.spinner.style.display = 'none';
			});
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/tabla-asignacion-contenidos/tabla-asignacion-contenidos.component.ts